import { CSSProperties, ReactNode } from 'react';

import { CheckboxContainer, LeftSection, RightSection } from './styled';

const BookerCheckboxContainer = ({
  leftSection,
  rightSection,
  justifyContent,
}: {
  leftSection?: ReactNode;
  rightSection?: ReactNode;
  justifyContent?: CSSProperties['justifyContent'];
}) => {
  return (
    <CheckboxContainer justifyContent={justifyContent}>
      <LeftSection>{leftSection}</LeftSection>
      <RightSection>{rightSection}</RightSection>
    </CheckboxContainer>
  );
};

export default BookerCheckboxContainer;
